export default __webpack_public_path__ + "static/media/vi_background.33910929.gif";